import React, { useState, useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import NavbarComponent from "./navbar";
import formarrow from "./images/forrmarrow.webp";
import Footer from "./footer";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    companyName: "",
    email: "",
    name: "",
    lastName: "",
    mobile: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [emailError, setEmailError] = useState(null); // Email validation error

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      if (!/^[a-zA-Z ]*$/.test(value)) return;
    }

    if (name === "mobile") {
      if (!/^[0-9]*$/.test(value)) return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Email validation on submit
    if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
      setEmailError("Please enter a valid email address.");
      setLoading(false);
      return; // Stop form submission
    } else {
      setEmailError(null); // Clear error if valid
    }

    console.log("Form Data Before Submitting:", formData);

    const apiUrl = `https://toodhu.com/toodhuapi/api/appToodhuContactUs?CompanyName=${formData.companyName}&Email=${formData.email}&Name=${formData.name}&MobileNo=${formData.mobile}&Message=${formData.message}`;

    try {
      const response = await axios.post(apiUrl, {}, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data.success) {
        window.alert(response.data.message || "Saved Successfully");
        setFormData({
          companyName: "",
          email: "",
          name: "",
          mobile: "",
          message: "",
        });
      } else if (response.data.error) {
        window.alert(response.data.errorMessage || "An error occurred.");
      }
      else{
        window.alert(response.data.message);
      }
    } catch (error) {
      window.alert(error.response?.data?.message || "Failed to submit form.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Toodhu",
    "url": "https://toodhu.com/contactform",
    "description": "Have questions or need support? Reach out to Toodhu by filling out our contact form, and our team will assist you promptly.",
    "inLanguage": "en",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Toodhu",
      "url": "https://toodhu.com"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://toodhu.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Contact Us",
          "item": "https://toodhu.com/contactform"
        }
      ]
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9500944451",
      "contactType": "customer support",
      "areaServed": "IN",
      "availableLanguage": "en"
    },
    "about": {
      "@type": "Organization",
      "name": "Toodhu",
      "url": "https://toodhu.com",
      "description": "Toodhu provides top-notch products and services, ensuring seamless business operations."
    }
  };



  return (
    <>
      <Helmet>
        <title>Contact Us | Get in Touch with Toodhu</title>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
        <meta name="description" content="Have questions or need support? Reach out to Toodhu by filling out our contact form, and our team will assist you promptly." />
        <meta name="keywords" content="Contact us, Toodhu support, Customer service, Reach out to Toodhu" />
        <link rel="canonical" href="https://toodhu.com/contact-us" />
        <meta name="robots" content="index,follow" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>

      </Helmet>

      <div className="contactbg" id="contactbg">
        <div className="py-5">
          <NavbarComponent />
        </div>

        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="discovertxt">Discover Seamless Collaboration, Smart Insights & Effortless Workflow</h2>
              <ul className="contactlist mt-4">
                <li className="pb-4">Enhances collaboration with seamless communication and teamwork.</li>
                <li className="pb-4">Optimizes workflow with smart automation and task management.</li>
                <li>Drives growth with real-time insights and data-driven decisions.</li>
              </ul>
            </div>

            <div className="col-md-6">
              <div className="p-4 shadow-lg bg-white" id="cntfrm">
                <h4 className="mb-3">See a demo with our team today</h4>
                {responseMessage && <p className="text-success">{responseMessage}</p>}
                {error && <p className="text-danger">{error}</p>}

                <form onSubmit={handleSubmit}>
                  <label className="form-label">Name*</label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />

                  <label className="form-label">Email*</label>
                  <input
                    type="email"
                    className={`form-control mb-3 ${emailError ? "is-invalid" : ""}`}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {emailError && <div className="text-danger">{emailError}</div>}

                  <label className="form-label">Mobile No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                  />

                  <label className="form-label">Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                  />

                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control mb-3"
                    rows="3"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>

                  <button type="submit" className="btn btn-dark rounded-pill px-4" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"} <span className="frmarw"><img src={formarrow} alt="arrow" /></span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
} 